import React, { createContext, useContext, useMemo } from 'react';

import { TBlockButton } from '../../views/EditableMessage/components/AddBlockButton/blocks/helpers/defineBlockButton';

type TLayoutType = 'root' | 'container' | 'column';

type TState = {
  currentLayout: TLayoutType;
  isLoopIteration: boolean;
};

const ROOT_LAYOUT = { currentLayout: 'root', isLoopIteration: false } as const;
const Context = createContext<TState>(ROOT_LAYOUT);

type Props = {
  children: React.ReactNode;
};
export function ColumnBlockLayout({ children }: Props) {
  const { isLoopIteration } = useContext(Context);
  const value = useMemo<TState>(() => ({ isLoopIteration, currentLayout: 'column' }), [isLoopIteration]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function SectionBlockLayout({ children }: Props) {
  const { isLoopIteration, currentLayout } = useContext(Context);
  const nCurrentLayout = currentLayout === 'column' ? 'column' : 'container';
  const value = useMemo<TState>(
    () => ({ isLoopIteration, currentLayout: nCurrentLayout }),
    [isLoopIteration, nCurrentLayout]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function LoopIterationLayout({ children }: Props) {
  const { currentLayout } = useContext(Context);
  const value = useMemo<TState>(() => ({ isLoopIteration: true, currentLayout }), [currentLayout]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useCurrentLayout() {
  return useContext(Context).currentLayout;
}

export function useIsLoopIteration() {
  return useContext(Context).isLoopIteration;
}

export function getBlockForLayout(button: TBlockButton, layout: TLayoutType) {
  switch (layout) {
    case 'root':
      return button.defaultBlock();
    case 'column':
      return button.defaultColumnBlock();
    case 'container':
      return button.defaultContainerBlock();
  }
}
